import { FlexBox, Label, Switch } from '@ui5/webcomponents-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStyles } from './HistoryCommentsSwitch.jss';

interface HistoryCommentsSwitchProps {
  checked: boolean;
  onChange: (event: CustomEvent<HTMLInputElement>) => void;
}

export const HistoryCommentsSwitch: React.FC<HistoryCommentsSwitchProps> = ({
  checked,
  onChange
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <FlexBox className={classes.switchContainer}>
      <Label data-testid="display-query-history-status-comments-switch-label">
        {t('display-query-history-status-comments-switch')}:
      </Label>
      <Switch
        role="switch"
        onChange={onChange}
        checked={checked}
        aria-checked={checked}
        data-testid="display-query-history-status-comments-switch"
        textOff={t('display-query-history-status-comments-switch-off')}
        textOn={t('display-query-history-status-comments-switch-on')}
        tooltip={t('display-query-history-status-comments-switch-tooltip')}
      />
    </FlexBox>
  );
};
